/**
 * Name: Slider
 */

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import Component from "@lunaweb/vega-reactor-js/src/patterns/Component";

export default class Slider extends Component {

  static settings = {};

  #swiper;
  #container;
  #itemsElement;
  #items;
  #pagination;
  #next;
  #prev;
  #foot;

  constructor (element, options = {}) {
    super(element, {
      ...Slider.settings,
      ...options
    });

    this.#container = this.element.querySelector('.js-slider-container');
    this.#itemsElement = this.element.querySelector('.js-slider-items');
    this.#items = this.element.querySelectorAll('.js-slider-item');
    this.#prev = this.element.querySelector('.js-slider-prev');
    this.#next = this.element.querySelector('.js-slider-next');
    this.#pagination = this.element.querySelector('.js-slider-pagination');
    this.#foot = this.element.querySelector('.js-slider-foot');
  }

  updateNavigation(swiper) {
    if (swiper.isLocked) {
      this.#foot.setAttribute('hidden', "");
    } else {
      this.#foot.removeAttribute('hidden');
    }
  }

  mount () {
    this.#swiper = new Swiper(this.#container, {
      modules: [Navigation, Pagination],
      slidesPerView: 'auto',
      spaceBetween: 12,
      freeMode: true,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: this.#next,
        prevEl: this.#prev,
      },
      pagination: {
        el: this.#pagination,
        type: "bullets",
      },
      on: {
        init: (swiper) => {
          this.updateNavigation(swiper);
        },
        slideChange: (swiper) => {
          this.updateNavigation(swiper);
        },
        beforeResize: (swiper) => {
          this.updateNavigation(swiper);
        }
      },
    });

    super.mount();
  }

  unmount () {
    this.#swiper.destroy();

    super.unmount();
  }
}
